export default __webpack_public_path__ + "static/media/mypic.adc695ab.png";